export function getApp(): string {
  return window.ads?.context?.platform ?? "app";
}
